import { jsx as _jsx } from "react/jsx-runtime";
var LogIn = function LogIn(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.0002 4H19.0002C19.5502 4 20.0002 4.45 20.0002 5V19C20.0002 19.55 19.5502 20 19.0002 20H17.0002C16.4502 20 16.0002 19.55 16.0002 19C16.0002 18.45 16.4502 18 17.0002 18H18.0002V6H17.0002C16.4502 6 16.0002 5.55 16.0002 5C16.0002 4.45 16.4502 4 17.0002 4ZM10.4 7.2004C10.844 6.8694 11.469 6.9594 11.8 7.4004L14.8 11.4004C15.06 11.7464 15.068 12.2204 14.818 12.5754L12.004 16.5754C11.809 16.8524 11.5 17.0004 11.185 17.0004C10.987 17.0004 10.786 16.9414 10.611 16.8184C10.159 16.5004 10.05 15.8764 10.368 15.4244L12.086 12.9824C12.0725 12.9837 12.0599 12.9875 12.0473 12.9913C12.0318 12.9958 12.0165 13.0004 12 13.0004H4C3.448 13.0004 3 12.5524 3 12.0004C3 11.4474 3.448 11.0004 4 11.0004H12H12.001L10.2 8.5994C9.869 8.1584 9.958 7.5314 10.4 7.2004Z",
      fill: color
    })
  });
};
export default LogIn;